import React, {CSSProperties, RefObject, useRef} from 'react';
import '../../styles/components/dashboard/progress-oval.scss';
import useIntersectionObserver from "../../services/intersection/intersection";

interface IProgressOval {
  pathClass: string | undefined,
  computedDashoffset: number,
  svgElement?: RefObject<SVGSVGElement>,
  pathElement?: RefObject<SVGPathElement>,
}

const path = document.querySelector('.completed-oval') as SVGPathElement | null;
const pathLength = path?.getTotalLength();

export default function ProgressOval({pathClass, computedDashoffset}: IProgressOval) {
  const svgElement = useRef<SVGSVGElement>(null);
  const pathElement = useRef<SVGPathElement>(null);
  const pathData = `M2 215.822C2 287.48 63.215 321 127.897 321c47.355 0 93.555-17.337 135.137-41.61C317.319 247.03 382 190.396 382 107.178 382 35.517 320.785 2 256.103 2c-47.356 0-93.556 17.336-135.137 41.608C66.681 75.971 2 132.604 2 215.822Z`;
  const entry = useIntersectionObserver(svgElement, {threshold: 0.25, freezeOnceVisible: true});
  const isVisible = !!entry?.isIntersecting;
  const svgIntersectionCheck = styleSVG(isVisible);
  const svgStyles: CSSProperties = {
    animationName: `${svgIntersectionCheck.animationName}`,
  }
  const computedOffset = drawOvalPath(computedDashoffset, pathElement);

  return (
    <svg ref={svgElement} viewBox="0 0 384 323" xmlns="http://www.w3.org/2000/svg" style={svgStyles}>
      <path className={`total-oval`} d={pathData} />
      <path ref={pathElement} className={`completed-oval ${pathClass}`} d={pathData}
        strokeDasharray={pathLength}
        strokeDashoffset={computedOffset}
      />
    </svg>
  );
}

function drawOvalPath(computedDashoffset: number, pathElement: RefObject<SVGPathElement>) {
  if (pathElement === null) {
    return 0;
  }
  if (pathElement.current) {
    // Uses Jake Archibald's path animation method
    // https://jakearchibald.com/2013/animated-line-drawing-svg/
    const pathLength = pathElement.current.getTotalLength();
    pathElement.current.style.transition = `none`;
    pathElement.current.style.strokeDasharray = `${pathLength}`;
    pathElement.current.style.strokeDashoffset = `${pathLength}`;
    pathElement.current.getBoundingClientRect();
    pathElement.current.style.transitionDelay = `600ms`;
    pathElement.current.style.transition = `all 1s ease-in-out`;
    pathElement.current.style.strokeDashoffset = `${computedDashoffset}`;
    pathElement.current.style.stroke = `#fff`;
  }
}

function styleSVG(isVisible: boolean) {
  if (isVisible) {
    return {
      animationName: `scaleOvalIn`,
    };
  } else {
    return {
      animationName: `none`,
    };
  }
}
